export default function profileDetails() {
  return {
    _id: false,
    type: 'droplet.profileDetails',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    ref: null,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/profile-details/droplet.schema.js